/**
 * window.__polarCheckout — касса Polar МОДАЛКОЙ поверх нашей страницы вместо
 * ухода на polar.sh (решение Фарида 2026-08-18: «касса не на другой странице,
 * как и на Тимбрике — тут же может оплатить»).
 *
 * На RU так было всегда (виджет ЮKassa рисуется прямо на /ru/register), а на
 * intl покупателя уносило на чужой домен: он терял из виду, у кого покупает, и
 * возвращался уже другой страницей.
 *
 * Как это работает: их embed.global.js (vendor/polar/embed.js, Apache-2.0)
 * поднимает iframe с кассой на весь экран и общается с нашей страницей через
 * postMessage — loaded / close / confirmed / success. На success ИХ ЖЕ код
 * уводит родителя на success_url сессии, то есть на нашу страницу /pro/done —
 * ничего дополнительно ловить не нужно.
 *
 * ⚠️⚠️ Сообщения приходят, только если сессия создана с `embed_origin` (это
 * делает PolarClient). Замерено 18.08 на живом tembrica: без него касса в
 * iframe РИСУЕТСЯ, но ни одного сообщения родителю не приходит — то есть
 * «выглядит рабочим», а `success` не наступает никогда. Поэтому здесь стоит
 * таймаут: не дождались `loaded` — уходим на их страницу, как раньше.
 * Это же спасает от заблокированного скрипта и старого браузера.
 *
 * Использование:
 *   window.__polarCheckout.open(url, { onClose: fn, onLoaded: fn })
 * Вызывать ТОЛЬКО с url, полученным от нашего сервера.
 */
(function () {
    'use strict';

    var DEFAULT_TIMEOUT_MS = 12000;

    function currentTheme() {
        try {
            var t = document.documentElement.getAttribute('data-theme');
            if (t === 'light' || t === 'dark') return t;
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) return 'light';
        } catch (_) {}
        return 'dark';   // тема сайта по умолчанию
    }

    function ae(stage, extra) {
        try {
            var p = { stage: stage };
            for (var k in (extra || {})) { if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k]; }
            if (window.__ae) window.__ae('checkout_embed', p);
        } catch (_) {}
    }

    function goHosted(url, why) {
        ae('fallback', { why: why });
        try { document.body.classList.remove('polar-no-scroll'); } catch (_) {}
        window.location.href = url;
    }

    window.__polarCheckout = {
        /**
         * @param {string} url  адрес кассы, выданный нашим сервером
         * @param {{onLoaded?:Function,onClose?:Function,timeout?:number,theme?:string}} [opts]
         */
        open: function (url, opts) {
            opts = opts || {};
            if (!url) return;

            var Embed = window.Polar && window.Polar.EmbedCheckout;
            if (!Embed || typeof window.Promise === 'undefined') {
                goHosted(url, Embed ? 'no_promise' : 'sdk_missing');
                return;
            }

            var settled = false;
            ae('open');

            var timer = setTimeout(function () {
                if (settled) return;
                settled = true;
                goHosted(url, 'timeout');
            }, opts.timeout || DEFAULT_TIMEOUT_MS);

            var pending;
            try {
                pending = Embed.create(url, { theme: opts.theme || currentTheme() });
            } catch (_) {
                clearTimeout(timer);
                settled = true;
                goHosted(url, 'create_threw');
                return;
            }

            pending.then(function (checkout) {
                if (settled) return;           // таймаут уже увёл на их страницу
                settled = true;
                clearTimeout(timer);
                ae('loaded');
                try {
                    checkout.addEventListener('close', function () {
                        ae('close');
                        if (opts.onClose) opts.onClose();
                    });
                    checkout.addEventListener('confirmed', function () { ae('confirmed'); });
                    // success ловим только ради счётчика: увод на success_url
                    // делает их же обработчик (иначе мы бы гонялись с ним).
                    checkout.addEventListener('success', function () { ae('success'); });
                } catch (_) {}
                if (opts.onLoaded) opts.onLoaded(checkout);
            }, function () {
                if (settled) return;
                settled = true;
                clearTimeout(timer);
                goHosted(url, 'create_rejected');
            });
        },
    };
})();
